import { applyFormat } from "components/ui/ui-helpers";

const DetailAssietteCotisation = (props) => {
  const { DetailAssiette } = props;

  const getIconStyle = (type) => {
    const icons = {
      charges: { emoji: "💼", background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)" },
      remuneration: { emoji: "💰", background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)" },
      dividendes: { emoji: "📊", background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)" },
      facultatives: { emoji: "🎯", background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" },
      avantages: { emoji: "🎁", background: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)" },
      abattement: { emoji: "📉", background: "linear-gradient(135deg, #64748b 0%, #475569 100%)" },
      epargne: { emoji: "🏦", background: "linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)" },
    };
    return icons[type] || { emoji: "📊", background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)" };
  };

  return (
    <>
      <div className="cotisations-container">
        <div className="cotisations-list-container">
          <div className="cotisations-header">
            <div className="header-column"></div>
            <div className="header-column">Libellé</div>
            <div className="header-column">Montant</div>
          </div>

          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("charges").background }}>
              {getIconStyle("charges").emoji}
            </div>
            <div className="card-column">Charges sociales obligatoires</div>
            <div className="card-column">{applyFormat(DetailAssiette?.DetailAssietteCharges, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>

          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("remuneration").background }}>
              {getIconStyle("remuneration").emoji}
            </div>
            <div className="card-column">Rémunération nette</div>
            <div className="card-column">{applyFormat(DetailAssiette?.DetailRemunerationNette, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>

          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("dividendes").background }}>
              {getIconStyle("dividendes").emoji}
            </div>
            <div className="card-column">Dividendes assujettis aux charges sociales</div>
            <div className="card-column">{applyFormat(DetailAssiette?.DetailAssietteDividendeBrut, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>

          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("facultatives").background }}>
              {getIconStyle("facultatives").emoji}
            </div>
            <div className="card-column">Cotisations facultatives</div>
            <div className="card-column">
              {applyFormat(DetailAssiette?.DetailCotisationsDeductibles + DetailAssiette?.DetailCotisationsNonDeductibles, "uint", { thousands: " ", decimal: ",", unit: " €" })}
            </div>
          </div>

          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("avantages").background }}>
              {getIconStyle("avantages").emoji}
            </div>
            <div className="card-column">Avantages en nature</div>
            <div className="card-column">{applyFormat(DetailAssiette?.DetailAvantageNature, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("epargne").background }}>
              {getIconStyle("epargne").emoji}
            </div>
            <div className="card-column">Intéressement, participation, abondement</div>
            <div className="card-column">{applyFormat(DetailAssiette?.DispositifsEpargne, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
          <div className="cotisations-card light-title">
            <div className="cotisations-card-icon" style={{ background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)", color: "#4f46e5" }}>
              📊
            </div>
            <div className="card-column">Assiette avant abattement</div>
            <div className="card-column">{applyFormat(DetailAssiette?.DetailAssietteAvantAbattement, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>

          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("abattement").background }}>
              {getIconStyle("abattement").emoji}
            </div>
            <div className="card-column">Abattement</div>
            <div className="card-column">- {applyFormat(DetailAssiette?.DetailAssietteAbattement, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>

          <div className="cotisations-card">
            <div className="cotisations-card-icon" style={{ background: getIconStyle("epargne").background }}>
              {getIconStyle("epargne").emoji}
            </div>
            <div className="card-column">Intéressement, participation, abondement</div>
            <div className="card-column">- {applyFormat(DetailAssiette?.DispositifsEpargne*0.74, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>

          <div className="cotisations-card light-title">
            <div className="cotisations-card-icon" style={{ background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)", color: "#22c55e" }}>
              💰
            </div>
            <div className="card-column">Assiette après abattement</div>
            <div className="card-column">{applyFormat(DetailAssiette?.DetailAssietteApresAbattement, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailAssietteCotisation;
